import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        container: {
            w: {base: `calc(100% - ${remCalc(32)})`, lg: '100%'},
            maxW: remCalc(1162),
            margin: {base: remCalc(16), lg: `${remCalc(16)} auto`},
            overflow: 'hidden',
            backgroundColor: 'background.light',
            display: 'flex',
            flexDirection: {base: 'column', lg: 'row'},
        },
        imageElement: {
            w: {base: '100%', lg: remCalc(342)},
            h: {base: remCalc(200), lg: remCalc(342)},
            objectFit: 'cover',
            objectPosition: 'center',
            display: 'block',
        },
        pspContentContainer: {
            display: 'flex',
            w: 'full',
            alignItems: 'center',
            flexDirection: 'column',
            justifyContent: {base: 'center', lg: 'flex-start'},
            paddingX: {base: remCalc(30), lg: remCalc(24)},
            paddingY: {base: remCalc(22), lg: remCalc(24)},
            backgroundColor: 'background.default',
        },
        pspThanksContentContainer: {
            gap: remCalc(12),
            display: 'flex',
            w: 'full',
            alignItems: 'center',
            flexDirection: 'column',
            justifyContent: {base: 'center', lg: 'flex-start'},
            paddingX: {base: remCalc(30), lg: remCalc(24)},
            paddingY: {base: remCalc(22), lg: remCalc(24)},
            backgroundColor: 'background.default',
        },
        contentContainer: {
            display: 'flex',
            w: {base: '100%', lg: `calc(100% - ${remCalc(342)})`},
            flexDirection: 'column',
            justifyContent: {base: 'center', lg: 'flex-start'},
            paddingX: {base: remCalc(30), lg: remCalc(24)},
            paddingY: {base: remCalc(22), lg: remCalc(24)},
        },
        thanksContainer: {
            w: {base: '100%', lg: remCalc(820)},
            maxW: {base: '100%', lg: `calc(100% - ${remCalc(342)})`},
            display: 'flex',
            flexDirection: 'column',
            textAlign: 'center',
            paddingX: {base: remCalc(30), lg: remCalc(24)},
            paddingY: {base: remCalc(30), lg: remCalc(24)},
            gap: {base: remCalc(14), lg: remCalc(16)},
            justifyContent: 'center',
        },
        thanksTitle: {
            fontSize: {base: remCalc(28), lg: remCalc(28)},
            lineHeight: {base: remCalc(30), lg: remCalc(30)},
            color: 'text.default',
            fontWeight: 'medium',
            mb: {base: remCalc(20), lg: remCalc(25)},
        },
        thanksDescription: {
            textStyle: 'body-medium',
            color: 'text.default',
            mb: {base: remCalc(10), lg: remCalc(15)},
        },
        thanksButton: {
            w: {base: '100%', lg: 'fit-content'},
            margin: '0 auto',
            paddingX: remCalc(40),
        },
        thanksNotes: {
            textStyle: 'body-small',
            color: 'text.default',
        },
        pspThanksTitle: {
            textAlign: 'center',
            fontSize: {base: remCalc(28), lg: remCalc(28)},
            lineHeight: {base: remCalc(30), lg: remCalc(30)},
            color: 'text.default',
            fontWeight: 'medium',
            mb: {base: remCalc(20), lg: remCalc(25)},
        },
        pspThanksDescription: {
            textAlign: 'center',
            textStyle: 'body-medium',
            color: 'text.default',
            mb: {base: remCalc(10), lg: remCalc(15)},
        },
        pspThanksNotes: {
            textAlign: 'center',
            textStyle: 'body-small',
            color: 'text.secondary',
        },
        title: {
            fontSize: {base: remCalc(20), lg: remCalc(28)},
            lineHeight: {base: remCalc(22), lg: remCalc(30)},
            color: 'text.default',
            fontWeight: 'medium',
            textAlign: {base: 'center', lg: 'left'},
        },
        description: {
            textStyle: {base: 'body-xsmall', lg: 'body-medium'},
            color: 'text.default',
            textAlign: {base: 'center', lg: 'left'},
            mt: remCalc(14),
            mb: remCalc(24),
            maxW: {base: 'unset', lg: remCalc(600)},
        },
        registrationFormStack: {
            position: 'relative',
        },
        pspRegistrationFormStack: {
            pY: remCalc(16),
            backgroundColor: 'background.default',
            position: 'relative',
            w: 'full',
        },
        errorMessage: {
            color: '#ce4635',
            fontSize: remCalc(11),
            position: 'absolute',
            bottom: {base: remCalc(44), lg: remCalc(53)},
        },
        pspErrorMessage: {
            color: '#ce4635',
            fontSize: remCalc(11),
            position: 'absolute',
            bottom: {base: remCalc(56), lg: remCalc(66)},
        },
    },
}
